import { render, staticRenderFns } from "./ExecCustomers.vue?vue&type=template&id=56459b54"
import script from "./ExecCustomers.vue?vue&type=script&lang=js"
export * from "./ExecCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports